import SpecDropdown from '../SpecDropdown/SpecDropdown';

interface IQuoteNewToolMonitorSpecs {
  displayInches?: string;
  pixels?: string;
  resolution?: string;
  fps?: string;
  onChangeSpec: (field: string, value: string) => void;
}

/**
 * Especificaciones técnicas para monitores dentro del formulario de creación de SKU desde cotización.
 * El tipo HD se carga desde el backend via SpecDropdown; el resto de campos son texto libre.
 */
const QuoteNewToolMonitorSpecs = ({
  displayInches,
  pixels,
  resolution,
  fps,
  onChangeSpec
}: IQuoteNewToolMonitorSpecs) => {
  return (
    <div className="specsGrid monitorSpecs">
      <div className="specField">
        <label className="fieldLabel">Pantalla*</label>
        <input
          className="specInput"
          placeholder='27"'
          value={displayInches ?? ''}
          onChange={e => onChangeSpec('displayInches', e.target.value)}
        />
      </div>
      <div className="specField">
        <label className="fieldLabel">Resolución*</label>
        <input
          className="specInput"
          placeholder="1920x1080"
          value={pixels ?? ''}
          onChange={e => onChangeSpec('pixels', e.target.value)}
        />
      </div>
      <SpecDropdown
        label="Tipo HD"
        paramName="tipoHD"
        placeholder="Sin especificar"
        value={resolution}
        onChange={value => onChangeSpec('resolution', value)}
      />
      <div className="specField">
        <label className="fieldLabel">Frecuencia*</label>
        <input
          className="specInput"
          placeholder="60hz"
          value={fps ?? ''}
          onChange={e => onChangeSpec('fps', e.target.value)}
        />
      </div>
    </div>
  );
};

export default QuoteNewToolMonitorSpecs;
